import { render, staticRenderFns } from "./MouseLayout.vue?vue&type=template&id=7900b709&scoped=true&"
import script from "./MouseLayout.vue?vue&type=script&lang=js&"
export * from "./MouseLayout.vue?vue&type=script&lang=js&"
import style0 from "./MouseLayout.vue?vue&type=style&index=0&id=7900b709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7900b709",
  null
  
)

export default component.exports